import { render, staticRenderFns } from "./DepenseForm.vue?vue&type=template&id=65f2eda2&scoped=true"
import script from "./DepenseForm.vue?vue&type=script&lang=js"
export * from "./DepenseForm.vue?vue&type=script&lang=js"
import style0 from "./DepenseForm.vue?vue&type=style&index=0&id=65f2eda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2eda2",
  null
  
)

export default component.exports